
import {Loader} from '@googlemaps/js-api-loader'

import {useEffect, useRef, useState} from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import {processGet} from '../../../../services/api'
import {useAuth} from '../../../modules/auth'
import {useIntl} from 'react-intl'
import {Navigate} from 'react-router-dom'
const MySwal = withReactContent(Swal)
export const WidgetMap = () => {
  const ROLE_MANAGER = parseInt(process.env.REACT_APP_ROLE_MANAGER + '')
  const ROLE_EMPLOYEE = parseInt(process.env.REACT_APP_ROLE_EMPLOYEE + '')
  const [redirect, setRedirect] = useState('')
  const intl = useIntl()

  const mapElement = useRef<any>()


  const {checkAuthorization} = useAuth()
  useEffect(() => {
    const fetchCoordinates = async (loader) => {
      const {Map} = await loader.importLibrary('maps')
      const {Marker} = await loader.importLibrary('marker')
      const {LatLngBounds, Size, Point, ControlPosition} = await loader.importLibrary('core')
      const response: any = await processGet('system-settings/servers/coordinates')
   

      const map = new Map(mapElement.current, {
        center: {lat: 0, lng: 0},
        zoom: 13,
        zoomControl: true,
        zoomControlOptions: {
          position: ControlPosition.TOP_RIGHT,
        },
      })
      const bounds = new LatLngBounds()

      response.data.forEach((server: any) => {
        if (server.lat == null || server.lng == null) return

        var image: null | string = null
        if (server.serverStatus === 2) {
          image = '/media/server-online.png'
        } else {
          image = '/media/server-offline.png'
        }
        const marker = new Marker({
          position: {lat: parseFloat(server.lat), lng: parseFloat(server.lng)},
          map: map,
          title: server.serverDescription,
          icon: {
            url: image,
            scaledSize: new Size(40, 40), // Ora funziona
            origin: new Point(0, 0), // Ora funziona
            anchor: new Point(20, 40), // Ora funziona
          },
        })

        marker.addListener('click', () => {
          handleMarkerClick(server)
        })
        bounds.extend(marker.getPosition())
      })

      map.fitBounds(bounds)
      /*  var iconFeatures: Array<Feature> = []
      
        
        const feature = new Feature(
          Object.assign(
            {
              geometry: new Point(fromLonLat([response.data[i].lng, response.data[i].lat])),
              name: response.data[i].serverDescription,
              serverid: response.data[i].id,
            },
            response.data[i]
          )
        )
        iconFeatures.push(feature)
      }
      if (iconFeatures.length === 0) {
        return
      }

      const featuresLayer = new VectorLayer({
        source: new VectorSource({
          features: iconFeatures,
        }),
        style: featureStyle,
      })

      const map = new Map({
        target: mapElement.current,
        layers: [
          // USGS Topo
          new TileLayer({
            source: new OSM(),
          }),

          featuresLayer,
        ],
        view: new View({
          projection: 'EPSG:3857',
          center: [0, 0],
          zoom: 2,
        }),
        controls: [],
      })
      let extent: any =
        featuresLayer?.getSource()?.getExtent() != undefined
          ? featuresLayer?.getSource()?.getExtent()
          : null

      map.getView().fit(extent, {
        padding: [60, 60, 60, 60],
      })

      if (parseInt(map.getView().getZoom() + '') > 12) {
        map.getView().setZoom(12)
      }
      map.render()

      map.on('click', function (evt: any) {
        console.log(evt)
        var feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
          return feature
        })

        if (feature) {
          var content = `<h3>Server ${feature.get('name')}</h3>
                <strong>${intl.formatMessage({
                  id: 'SYSTEM_SETTINGS.SERVERS.SERVER_STATUS',
                })}: </strong> ${feature.get('serverStatus') === 2 ? 'online' : 'offline'}
                <strong>${intl.formatMessage({
                  id: 'SYSTEM_SETTINGS.SERVERS.USERNAME',
                })}: </strong> ${feature.get('serverUsername')}
                <strong>${intl.formatMessage({
                  id: 'SYSTEM_SETTINGS.SERVERS.LAST_ONLINE',
                })}: </strong> ${intl.formatDate(
            feature.get('lastOnlineStatus')
          )} ${intl.formatTime(feature.get('lastOnlineStatus'))}
                <strong>${intl.formatMessage({
                  id: 'SYSTEM_SETTINGS.SERVERS.LAST_OFFLINE',
                })}: </strong> ${intl.formatDate(
            feature.get('lastOfflineStatus')
          )} ${intl.formatTime(feature.get('lastOfflineStatus'))}`
          let position: any = [920, 283]
          MySwal.fire({
            toast: true,
            position: position,
            confirmButtonText: intl.formatMessage({id: 'GENERIC.EDIT'}),
            cancelButtonText: intl.formatMessage({id: 'GENERIC.OK'}),
            showCancelButton: true,
            showConfirmButton: checkAuthorization([ROLE_MANAGER]),
            timerProgressBar: false,
            didOpen: (toast) => {
              toast.onmouseenter = Swal.stopTimer
              toast.onmouseleave = Swal.resumeTimer
            },

            title: content,
          }).then((result) => {
            if (result.isConfirmed) {
              setRedirect(`/system-settings/servers/edit/${feature?.get('serverid')}`)
            }
          })
        } else {
        }
      })
      // save map and vector layer references to state
      setMap(map)
      setFeaturesLayer(featuresLayer)*/
    }

    const initMap = async () => {
      const loader = new Loader({
        apiKey: window['config'].gmaps_api_key,
        version: 'weekly',
        libraries: [], // opzionale, se serve Places API
      })

      fetchCoordinates(loader)
    }

    initMap()
  }, [])

  function handleMarkerClick(data: any) {
    var content = `<h3>Server ${data.serverDescription}</h3>
                <strong>${intl.formatMessage({
                  id: 'SYSTEM_SETTINGS.SERVERS.SERVER_STATUS',
                })}: </strong> ${data.serverStatus === 2 ? 'online' : 'offline'}
                <strong>${intl.formatMessage({
                  id: 'SYSTEM_SETTINGS.SERVERS.USERNAME',
                })}: </strong> ${data.serverUsername}
                <strong>${intl.formatMessage({
                  id: 'SYSTEM_SETTINGS.SERVERS.LAST_ONLINE',
                })}: </strong> ${intl.formatDate(data.lastOnlineStatus)} ${intl.formatTime(
      data.lastOnlineStatus
    )}
                <strong>${intl.formatMessage({
                  id: 'SYSTEM_SETTINGS.SERVERS.LAST_OFFLINE',
                })}: </strong> ${intl.formatDate(data.lastOfflineStatus)} ${intl.formatTime(
      data.lastOfflineStatus
    )}`
    let position: any = [920, 283]
    MySwal.fire({
      toast: false,
      allowOutsideClick: true,
      
      position: position,
      confirmButtonText: intl.formatMessage({id: 'GENERIC.EDIT'}),
      cancelButtonText: intl.formatMessage({id: 'GENERIC.OK'}),
      showCancelButton: true,
      showConfirmButton: checkAuthorization([ROLE_MANAGER]),
      timerProgressBar: false,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer
        toast.onmouseleave = Swal.resumeTimer
      },

      title: content,
    }).then((result) => {
      if (result.isConfirmed) {
        setRedirect(`/system-settings/servers/edit/${data.id}`)
      }
    })
  }

  return (
    <>
      {redirect && <Navigate to={redirect} />}
      <div
        ref={mapElement}
        style={{width: '100%', height: '500px'}}
        className='map-container'
      ></div>
    </>
  )
}
